import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Market Overwatch panel art: a half-circle sentiment gauge with a needle on
 * the left, and three breadth bars (advancers, decliners, unchanged) at right.
 *
 * The gauge track uses `--muted-foreground` at low alpha rather than `--muted`:
 * in the dark themes `--muted` is within two points of `--card`, so a `--muted`
 * track vanishes against the card this art sits on.
 */

/** [bar top y, filled width, fill] */
const BREADTH: [number, number, string][] = [
  [40, 30, 'hsl(var(--positive) / 0.65)'],
  [56, 18, 'hsl(var(--negative) / 0.6)'],
  [72, 12, 'hsl(var(--muted-foreground) / 0.6)'],
]

export function MarketOverwatchArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      {/* Gauge track, then the filled sweep up to the needle. */}
      <path
        d="M16 66 A30 30 0 0 1 76 66"
        fill="none"
        stroke="hsl(var(--muted-foreground) / 0.3)"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M16 66 A30 30 0 0 1 69 46.7"
        fill="none"
        stroke="hsl(var(--primary))"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M46 66 L65.5 49.6"
        fill="none"
        stroke="hsl(var(--foreground) / 0.7)"
        strokeWidth="3"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
      <circle cx={46} cy={66} r={3.5} fill="hsl(var(--foreground) / 0.5)" />

      <rect x={106} y={20} width={26} height={4} rx={2} fill="hsl(var(--foreground) / 0.2)" />
      {BREADTH.map(([y, width, fill]) => (
        <g key={y}>
          <rect x={106} y={y} width={42} height={8} rx={3} fill="hsl(var(--foreground) / 0.1)" />
          <rect x={106} y={y} width={width} height={8} rx={3} fill={fill} />
        </g>
      ))}
    </svg>
  )
}
